import React from "react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./AppRoutes";
import { theme } from "./theme";
import { store } from "./app/store";

export function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Provider store={store}>
                <BrowserRouter basename={"/app/subscriber-feedback"}>
                    <AppRoutes />
                </BrowserRouter>
            </Provider>
        </ThemeProvider>
    );
}
